import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { withRouter } from "react-router-dom";




class Header extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            userLoggedIn: false,
            loginname: null,
            userloginid: null
        }
        this.logoutUser = this.logoutUser.bind(this);
    }

    componentDidMount() {
        this.setUserInfo();
	}

    logoutUser = () => {
        this.setState({userLoggedIn: false});
        localStorage.clear();
        this.props.history.push('/login');
    }

    setUserInfo = () => {
        var userinfo = JSON.parse(localStorage.getItem('userinfo'));
        if(userinfo){
            this.setState({
                loginname: userinfo.roleinfo.loginname,
                userloginid: userinfo.roleinfo.userloginid,
                userLoggedIn: true
            })
        } else{
            return;
        }

    }

    render() {
        return (

            < nav className="main-header navbar navbar-expand navbar-white navbar-light custom-navbar nav-z-index" id="ml_0" >
                < ul className="navbar-nav" >
                    <li className="nav-item">
                        <a className="nav-link" id="mbl_menu" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars"></i></a>
                    </li>

                </ul >

                <form class="form-inline ml-3">
                    <div class="input-group input-group-sm" style={{ marginLeft: -25 }}>
                        <img src="dist/img/logo.png" alt="Logo" style={{ width: 200 }} class="img-fluid mr-2 ml-2" />
                    </div>
                    <div class="input-group input-group-sm">
                        <h6 class=" pt-2 text-white" style={{ marginLeft: 360 }}>Digital Comfort Guide - Admin Portal</h6>
                    </div>
                </form>

                {this.state.userLoggedIn && (
                    < ul className="navbar-nav top-nav-mbl-hide ml-auto" >
                        <li className="nav-item">
                            <a onClick={this.logoutUser} className="nav-link">
                                <i className="fas fa-sign-in-alt"></i>
                            </a>
                        </li>
                    </ ul>
                )}
            </nav >

        );
    }
}
export default withRouter(Header);